<template>
  <div id="app">
    <MatrixInput />
  </div>
</template>

<script>
import MatrixInput from './components/MatrixInput.vue';

export default {
  components: {
    MatrixInput,
  },
};
</script>

<style>


</style>